import { BaseStore } from 'fluxible/addons';

/**
 * For helping ensure onboarding prompts are mutually exclusive to each other and in priority order
 */
export default class OnboardingPromptStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.prompts = {};
    }

    register(key, priority) {
        this.prompts[key] = priority;
        this.emitChange();
    }

    unregister(key) {
        delete this.prompts[key];
        this.emitChange();
    }

    getPrompts() {
        return this.prompts;
    }
}
OnboardingPromptStore.storeName = 'OnboardingPromptStore';



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/onboarding-prompt-store.js